import { blue } from "@ant-design/colors";
import { ArrowLeftOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select, Space, Typography } from "antd";
import ServiceApi from "apis/ServiceApi";
import { showNotification, validateEmail, validatePhoneNumber } from "common";
import { formatterNumber } from "helpers/formatNumber";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function FormExtend({
  setLoading,
  dataCert,
  listPackage,
  fetchDataDetail,
  nextStep,
  dataCheckReq,
  requestType
}) {
  const history = useHistory();

  const [form] = Form.useForm();
  const [findPackage, setFindPackage] = useState();
  const packageId = Form.useWatch("packageId", form);
  useEffect(() => {
    if (dataCert) {
      form.setFieldsValue({
        name: dataCert?.name,
        phone: dataCert?.phone,
        email: dataCert?.email,
      });
    }
    if (dataCheckReq) {
      form.setFieldsValue({
        packageId: dataCheckReq?.packageId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCert, dataCheckReq]);

  useEffect(() => {
    const findPackage = listPackage.find((item) => item.id === packageId);
    if (findPackage) {
      setFindPackage(findPackage);
      form.setFieldsValue({
        price: `${formatterNumber(findPackage?.price)} VNĐ`,
        total_price: `${formatterNumber(findPackage?.price)} VNĐ`,
        priceSale: null,
      });
      if (findPackage?.priceSale) {
        form.setFieldsValue({
          priceSale: `${formatterNumber(findPackage?.priceSale)} VNĐ`,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageId]);

  const onGoBack = () => {
    history.goBack();
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);

      let request = {
        ...values,
        requestId: dataCheckReq?.id,
        requestType
      };

      handleRequest(ServiceApi.createrequestcapbu, 200, request);
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    }
  };

  const handleRequest = async (apiFunction, status, ...args) => {
    try {
      const res = await apiFunction(...args);
      if (res?.data?.status === status) {
        await nextStep();
      } else {
        showNotification("error", res?.data?.message, "Thông báo");
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const genderInfoPriceSale = (packageItem = null) => {
    if (packageItem) {
      let money = 0;
      if (packageItem.priceSale) {
        money = packageItem.price - packageItem.priceSale;
      }
      return <>* Tiết kiệm {`${formatterNumber(money)} VNĐ`} so với giá gốc</>;
    }
  };

  return (
    <Col span={24} md={24}>
      <Form
        onFinish={onFinish}
        layout="vertical"
        className="noti-extend-form"
        form={form}
      >
        <Form.Item
          label="Khách hàng"
          name="name"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập khách hàng đầy đủ!",
            },
          ]}
        >
          <Input  disabled/>
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập email đầy đủ!",
            },
            {
              validator: validateEmail,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Số điện thoại"
          name="phone"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập số điện thoại đầy đủ!",
            },
            {
              validator: validatePhoneNumber,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Gói năm"
          name="packageId"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn gói năm!",
            },
          ]}
        >
          <Select
            placeholder="Chọn gói năm"
            options={listPackage}
            onChange={(value) => form.setFieldsValue({ packageId: value })}
          ></Select>
        </Form.Item>

        <Form.Item
          label={
            <Typography.Text
              strong
            >
              Giá niêm yết
            </Typography.Text>
          }
          name="price"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập đơn giá đầy đủ!",
            },
          ]}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label={
            <Typography.Text
              strong
              className=""
              type="danger"
            >
              GIÁ ƯU ĐÃI (giá đã bao gồm VAT)
            </Typography.Text>
          }
          name="priceSale"
          extra={
            <Typography.Text type="danger">
              {findPackage?.priceSale ? genderInfoPriceSale(findPackage) : ""}
            </Typography.Text>
          }
        >
          <Input disabled />
        </Form.Item>
        <Form.Item>
          <Row justify="center">
            <Space>
              <Button
                icon={<ArrowLeftOutlined />}
                // type="primary"
                onClick={onGoBack}
              >
                Quay lại
              </Button>
              <Button icon={<SendOutlined />} type="primary" htmlType="submit">
                Tiếp tục
              </Button>
            </Space>
          </Row>
        </Form.Item>
      </Form>
    </Col>
  );
}
